import { render, staticRenderFns } from "./access-points.vue?vue&type=template&id=3f97be76&"
import script from "./access-points.vue?vue&type=script&lang=js&"
export * from "./access-points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports